import React from 'react';
import { useParams } from 'react-router-dom';
import { useStore } from '../../../../store';
import DownwardIcon from '../../../../../../assets/sme/quiz/downward_icon.png';
import leftTest from '../../../../../../assets/student-training/quiz/quiz.png';
import icon from '../../../../../../assets/student-training/quiz/pen-tool.png';

interface ISection0Props {
  settings: any;
}

const Section0: React.FunctionComponent<ISection0Props> = ({ settings }) => {
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = 'quiz';
  const { updateParagraphState } = useStore();

  const onStart = async () => {
    updateParagraphState(p_course, p_topic, '1', 'completed', []);
    setTimeout(() => {
      document
        .querySelectorAll('[data-paragraph]')[1]
        ?.scrollIntoView({ behavior: 'smooth' });
    }, 20);
  };

  return (
    <div className="course-landing-content">
      <div className="quiz-text course-landing-text">
        <div className="title">
          <div className="icon">
            <img src={icon} alt="" />
          </div>
          {settings?.message}
        </div>
        <div className="subtitle">{settings?.subtitle}</div>
        <div
          className="description"
          dangerouslySetInnerHTML={{ __html: settings?.description }}
        />
        <div className="quiz-btn" onClick={onStart}>
          <img src={DownwardIcon} alt="" />
          {settings?.startBtn}
        </div>
      </div>
      <div className="quiz-test">
        <img src={leftTest} alt="" />
      </div>
    </div>
  );
};

export default Section0;
